import React from 'react';
import { Link } from 'react-router-dom';
import settingSidebarMenusData from '@/layout/admin/settingSidebarMenusData';
import { cn } from '@/lib/utils';

const SettingSidebarCard = () => {
    return (
        <>
            <button className="settings-btn w-full md:hidden flex items-center justify-center gap-2 p-2 rounded bg-primary text-white">
                <span className="capitalize">Settings Menu</span>
                <i className="fa-solid fa-chevron-down text-sm"></i>
            </button>
            <div className="h-0 overflow-hidden md:h-auto md:overflow-auto transition-all duration-300">
                <nav className="db-card p-3">
                    {settingSidebarMenusData.map((item) => (
                        <Link key={item.id ?? item.url} to={{ pathname: item.url }} className="db-tab-btn">
                            <i className={cn('text-sm', item.icon)}></i>
                            {item.text}
                        </Link>
                    ))}
                </nav>
            </div>
        </>
    );
};

export default SettingSidebarCard;
